import { render, staticRenderFns } from "./RobotListPanel.vue?vue&type=template&id=0a794680&scoped=true"
import script from "./RobotListPanel.vue?vue&type=script&lang=js"
export * from "./RobotListPanel.vue?vue&type=script&lang=js"
import style0 from "./RobotListPanel.vue?vue&type=style&index=0&id=0a794680&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a794680",
  null
  
)

export default component.exports